import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import { axiosInit } from "./axios-interceptor";
import VueGtag from "vue-gtag";

Vue.use(
  VueGtag,
  {
    config: { id: process.env.VUE_APP_ANALYTICS_ID },
    appName: "Rating Disclosure External",
    pageTrackerScreenviewEnabled: true,
  },
  router,
);
Vue.config.productionTip = false;

axiosInit();

new Vue({
  router,
  render: h => h(App),
}).$mount("#app");
